import classNames from "classnames";

import { ReactComponent as IconPromoter } from "../../assets/ic-promoter.svg";

import styles from "./index.module.scss";

const PromoterIcon = ({ isFirst, isNotOnlyBadge, noMargin }) => {
  const className = classNames(
    "flex-shrink-0",
    styles.icon,
    isFirst && styles.top,
    isNotOnlyBadge && styles.notOnlyIcon,
    noMargin && styles.withoutMargin,
  );

  return <IconPromoter className={className} />;
};

export default PromoterIcon;
